import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/bookings", label: "Bookings" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 h-[78px] flex items-center justify-between">
        <Logo size="md" />

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-[0.18em] uppercase font-medium transition-colors duration-300 ${
                  isActive ? "text-[var(--accent)]" : "text-white/85 hover:text-[var(--accent)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/bookings" className="hidden md:inline-flex btn-accent" data-testid="nav-book-now">
            Book Now
          </Link>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((s) => !s)}
            data-testid="nav-menu-toggle"
            aria-label="Open menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden bg-[#0a0a0a] border-t border-white/5 px-6 py-6">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base tracking-[0.18em] uppercase ${
                    isActive ? "text-[var(--accent)]" : "text-white/85"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/bookings" className="btn-accent mt-2 self-start" data-testid="mobile-book-now">
              Book Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
